// src/pages/UsageTutorials.jsx
import React, { Component, Fragment } from "react";
import { Helmet } from 'react-helmet';
import HeaderOne from '../components/header/HeaderOne'; // Adjusted path
import Footer from '../components/footer/Footer'; // Adjusted path
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp, FiPlayCircle, FiExternalLink } from "react-icons/fi"; // Added some icons
import Breadcrumb from "../components/common/Breadcrumb"; // Adjusted path

// Updated tutorial data with correct links
const tutorialCategories = [
    {
        name: "Getting Started",
        tutorials: [
            { id: "gs001", title: "Installation, First Launch, and Settings", description: "A quick guide to installing Eidocell and taking your first look.", link: "/usage/tutorials/installation", external: false },
            { id: "gs002", title: "Importing Your First Dataset", description: "Learn how to import and organize your images.", link: "/usage/tutorials/importing-data", external: false },
        ]
    },
    {
        name: "Core Techniques",
        tutorials: [
            { id: "ct001", title: "Basic Image Segmentation & Scale Calibration", description: "Step-by-step guide to segmenting cells and adjusting cell scale for accurate measurements.", link: "/usage/tutorials/basic-segmentation", external: false },
            { id: "ct003", title: "Efficient Clustering & Available Parameters", description: "Understand how to run and parameterize unsupervised clustering, and manage resulting clusters.", link: "/usage/tutorials/clustering", external: false },
            { id: "ct003", title: "Data Visualization: Plots and Gating Strategies", description: "How to create insightful plots and use them to explore and understand cell populations.", link: "/plotting-gating", external: false },
        ]
    },
    {
        name: "Advanced Topics",
        tutorials: [
            // { id: "at000", title: "Comprehensive Feature Extraction", description: "Exploring the range of features Eidocell can extract and how to configure this process.", link: "/usage/tutorials/feature-extraction", external: false, new: true }, // Placeholder for feature extraction
            { id: "at001", title: "Fine-tuning Models & Custom Classification", description: "Learn to adapt models for feature extraction or train custom classifiers for your specific datasets.", link: "/usage/tutorials/fine-tuning", external: false, new: false },
            { id: "at003", title: "Custom Python Preprocessing Scripts", description: "How to preprocess your data on import using your own Python scripts.", link: "/usage/tutorials/custom-preprocessing", external: false, new: false },
            { id: "at002", title: "Batch Processing and Automation (Conceptual)", description: "Tips for analyzing large datasets efficiently (feature planned).", link: "#", external: false },

        ]
    },
];


class UsageTutorials extends Component {
        renderTutorialItem(tutorial) {
        // Corrected href logic:
        // If the link is just "#", keep it as is (for placeholder links).
        // Otherwise, prepend "#" for client-side routing with HashRouter.
        const linkTarget = tutorial.link === "#" ? "#" : `${tutorial.link}`; // <--- THIS LINE IS CORRECTED

        return (
            <div className="tutorial-item card" key={tutorial.id}>
                <div className="card-body">
                    <h4 className="card-title">
                        {/* Use linkTarget for both a tags */}
                        <a href={linkTarget} target={tutorial.external ? "_blank" : "_self"} rel={tutorial.external ? "noopener noreferrer" : ""}>
                            {tutorial.title}
                            {tutorial.external && <FiExternalLink className="external-link-icon" />}
                            {tutorial.new && <span className="badge new-badge">New</span>}
                        </a>
                    </h4>
                    <p className="card-text">{tutorial.description}</p>
                    {/* Use linkTarget for both a tags */}
                    <a href={linkTarget} target={tutorial.external ? "_blank" : "_self"} rel={tutorial.external ? "noopener noreferrer" : ""} className="btn btn-primary">
                        <FiPlayCircle /> Watch / Read Tutorial
                    </a>
                </div>
            </div>
        );
    }

    render() {
        return (
            <Fragment>
                <Helmet>
                    <title>Eidocell Tutorials | Learn Image Analysis</title>
                    <meta name="description" content="Find step-by-step tutorials and guides for using Eidocell. Master single-cell image analysis from basics to advanced techniques." />
                </Helmet>

                <HeaderOne />

                <Breadcrumb title={'Eidocell Tutorials'} />

                <div className="main-content-area ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-10 offset-lg-1">
                                <div className="tutorials-page-content">
                                    <p className="lead text-white opacity-90">
                                        Here you'll find a collection of tutorials created to help you get a grasp of the app's main features. 
                                        Start with the basics or jump to a specific topic to enhance your Eidocell skills.
                                    </p>

                                    {tutorialCategories.map(category => (
                                        <section id={`category-${category.name.toLowerCase().replace(/\s+/g, '-')}`} className="tutorial-category mb--50" key={category.name}>
                                            <h2 className="category-title">{category.name}</h2>
                                            <div className="tutorial-list">
                                                {category.tutorials.map(tutorial => this.renderTutorialItem(tutorial))}
                                            </div>
                                        </section>
                                    ))}

                                    <section className="request-tutorial mt--50">
                                        <h3 className="text-white">Can't find what you're looking for?</h3>
                                        <p className="text-white opacity-85">
                                            If there's a specific topic or feature you'd like an explanation on (or if you have other feedback), please let us know by <a href="https://github.com/xuzzu/eidocell/issues" target="_blank" rel="noopener noreferrer">opening an issue on GitHub</a>.
                                        </p>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />

                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
            </Fragment>
        )
    }
}

export default UsageTutorials;